import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Snowfall from 'react-snowfall'
import snowflake from '../../assets/animation/snowflake.png';
const snowflake1 = document.createElement('img')
snowflake1.src = snowflake;
const snowflake2 = document.createElement('img')
snowflake2.src = snowflake;
const images = [snowflake1, snowflake2]

class MySnow extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    return (    
      <Snowfall snowflakeCount={this.props.snowflakeCount} images={images} radius={this.props.radius}/> 
    );
  }
}
MySnow.propTypes = {
  snowflakeCount: PropTypes.any,
  radius: PropTypes.array
};
export default MySnow
  